import SpectrumLoginConfirmModal from "./SpectrumLoginConfirmModal";

export default SpectrumLoginConfirmModal;
